export default "__VITE_ASSET__97825081__"